import { z } from 'zod';
import { PROMOTION_CONSTRAINTS } from './constraints.js';
const { name } = PROMOTION_CONSTRAINTS;
export const promotionNameSchema = z
    .string({ error: `${name.label} is required` })
    .trim()
    .min(1, `${name.label} is required`)
    .max(name.maxLength, `${name.label} must be ${name.maxLength} characters or fewer`);
//# sourceMappingURL=promotion-name-schema.js.map